import { Controller } from 'stimulus';

/**
 * Keeps the "Add device model" form's submit button disabled until the user
 * picks a device model from the select. Prevents accidental submissions of
 * the blank/placeholder option, which the controller would 404 on anyway.
 */
export default class extends Controller {
  static targets = ['select', 'submit'];

  connect() {
    this.update();
  }

  update() {
    this.submitTarget.disabled = this.selectTarget.value === '';
  }
}
